"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButton = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const base_ui_components_atoms__atoms_1 = require("@motorata/base-ui.components.atoms._atoms");
const base_ui_components_atoms_icon_1 = __importDefault(require("@motorata/base-ui.components.atoms.icon"));
const IconButton = (_a) => {
    var { icon, size = "L", onClick, style } = _a, rest = __rest(_a, ["icon", "size", "onClick", "style"]);
    return (react_1.default.createElement(StyledIconButton, Object.assign({ size: size, onClick: onClick, style: style }, rest),
        react_1.default.createElement(base_ui_components_atoms_icon_1.default, { icon: icon })));
};
exports.IconButton = IconButton;
const StyledIconButton = styled_components_1.default.button `
  ${base_ui_components_atoms__atoms_1.common};
  cursor: pointer;
  border: none;
  background: ${({ theme, background = "background" }) => { var _a; return (_a = theme.color[background]) !== null && _a !== void 0 ? _a : background; }};
  color: ${({ theme, color = "second" }) => { var _a; return (_a = theme.color[color]) !== null && _a !== void 0 ? _a : color; }} !important;
  padding: 5px;
  border-radius: 50%;
  width: calc(${({ theme, size }) => theme.font[size]} + 10px);
  height: calc(${({ theme, size }) => theme.font[size]} + 10px);
  display: flex;
  justify-content: center;
  align-items: center;
  
  svg {
    width: ${({ theme, size }) => theme.font[size]};
    display: block !important;
  }

  &:hover {
    ${({ theme, hoverColor }) => {
    var _a;
    return hoverColor &&
        (0, styled_components_1.css) `
        svg {
          color: ${(_a = theme.color[hoverColor]) !== null && _a !== void 0 ? _a : hoverColor};
        }
      `;
}};
  }
`;
//# sourceMappingURL=IconButton.js.map